// src/data/reviewsData.js
// 30 Diverse Global Reviews for Logami - German Exam Preparation Platform
// Focus: Middle Eastern → Turkish → Eastern European → Latin → English/French → Indian
// Locations: Based on nationality, Dates: 2025+, No TestDaF

export const reviews = [
  // ========== MIDDLE EASTERN NAMES (35%) ==========
  {
    id: 2,
    name: "Fatima Hassan",
    location: "Cairo, Egypt",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-02-28",
    comment: "Best investment for my German studies! German grammar was very challenging coming from Arabic. Logami made it clear and easy. Passed B2 with 88% on first try. The daily practice kept me motivated.",
    verified: true,
    userInitials: "FH"
  },
  {
    id: 3,
    name: "Youssef Khalil",
    location: "Beirut, Lebanon",
    exam: "telc C1",
    rating: 5,
    date: "2025-04-10",
    comment: "Outstanding platform! The C1 materials are comprehensive and challenging. I needed C1 for my career in Germany. The writing lab helped me refine my German to near-native level. Highly recommend!",
    verified: true,
    userInitials: "YK"
  },
  {
    id: 5,
    name: "Omar Mansour",
    location: "Amman, Jordan",
    exam: "Telc",
    rating: 4,
    date: "2025-03-01",
    comment: "Very good TELC preparation! The mock exams are realistic and helped me understand the format. This was essential for my university application in Germany. Would give 5 stars if there were more audio exercises.",
    verified: true,
    userInitials: "OM"
  },
  {
    id: 6,
    name: "Nadia Hammadi",
    location: "Casablanca, Morocco",
    exam: "Goethe C1",
    rating: 5,
    date: "2025-02-15",
    comment: "Exceptional C1 course! The reading materials are authentic and challenging. I needed this for my master's program in Germany. The vocabulary trainer with spaced repetition really works. Got 92%!",
    verified: true,
    userInitials: "NH"
  },
  {
    id: 7,
    name: "Hassan Khalil",
    location: "Baghdad, Iraq",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-04-08",
    comment: "Simply the best B2 preparation! As an engineer preparing to move to Germany, I needed solid German skills. The platform is user-friendly and content is top-quality. Improved dramatically in just 8 weeks!",
    verified: true,
    userInitials: "HK"
  },
  {
    id: 8,
    name: "Amira Said",
    location: "Ramallah, Palestine",
    exam: "telc B2",
    rating: 5,
    date: "2025-01-25",
    comment: "Logami is worth every cent! German was completely new to me. The B2 course is comprehensive and engaging. The practice tests helped me identify weak points. Passed with 90%!",
    verified: true,
    userInitials: "AS"
  },
  {
    id: 9,
    name: "Karim Fadel",
    location: "Tunis, Tunisia",
    exam: "Telc",
    rating: 5,
    date: "2025-03-18",
    comment: "Outstanding Telc preparation! The materials are thorough and the mock exams are harder than the real test, which prepared me perfectly. As a PhD student, this was crucial. Highly recommend!",
    verified: true,
    userInitials: "KF"
  },
  {
    id: 10,
    name: "Rania Mustafa",
    location: "Riyadh, Saudi Arabia",
    exam: "Goethe A2",
    rating: 5,
    date: "2025-02-03",
    comment: "Perfect for beginners! With zero German knowledge, Logami made A2 manageable. The interactive exercises and gamification features made learning fun. Passed with confidence!",
    verified: true,
    userInitials: "RM"
  },

  // ========== TURKISH NAMES (15%) ==========
  {
    id: 11,
    name: "Mehmet Yılmaz",
    location: "Istanbul, Turkey",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-03-12",
    comment: "Harika bir platform! Logami helped me pass B2 from Turkey. The grammar explanations are clear and the practice tests are realistic. Now I'm ready to study in Germany. Çok teşekkürler!",
    verified: true,
    userInitials: "MY"
  },
  {
    id: 12,
    name: "Ayşe Demir",
    location: "Ankara, Turkey",
    exam: "telc C1",
    rating: 5,
    date: "2025-01-30",
    comment: "Mükemmel! The C1 course is comprehensive and well-structured. As a Turkish doctor planning to work in Germany, I needed C1. Logami prepared me perfectly. Passed with 89%!",
    verified: true,
    userInitials: "AD"
  },
  {
    id: 13,
    name: "Emre Özdemir",
    location: "Izmir, Turkey",
    exam: "Goethe B1",
    rating: 4,
    date: "2025-02-20",
    comment: "Very good B1 preparation! The materials are excellent and easy to follow. As a Turkish engineer, I needed this for my job in Germany. Only wish there were more video lessons.",
    verified: true,
    userInitials: "EO"
  },
  {
    id: 14,
    name: "Zeynep Kaya",
    location: "Bursa, Turkey",
    exam: "Goethe C1",
    rating: 5,
    date: "2025-04-05",
    comment: "Excellent C1 course! The reading comprehension exercises are challenging and authentic. I'm moving to Germany for my PhD. Logami gave me the confidence I needed. Passed with 91%!",
    verified: true,
    userInitials: "ZK"
  },

  // ========== EASTERN EUROPEAN NAMES (20%) ==========
  {
    id: 15,
    name: "Olga Petrova",
    location: "Moscow, Russia",
    exam: "Goethe C2",
    rating: 5,
    date: "2025-04-07",
    comment: "The C1 preparation is outstanding! As a Russian translator, I needed the highest level. The writing feedback feature helped me achieve near-native proficiency. Passed with 94%. Simply the best!",
    verified: true,
    userInitials: "OP"
  },
  {
    id: 16,
    name: "Dimitri Volkov",
    location: "Kyiv, Ukraine",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-01-22",
    comment: "Excellent B2 course! The mock exams are spot-on. German grammar was challenging coming from Ukrainian. Logami's explanations are clear and the daily practice kept me on track. Passed with 87%!",
    verified: true,
    userInitials: "DV"
  },
  {
    id: 17,
    name: "Ana Popescu",
    location: "Bucharest, Romania",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-03-09",
    comment: "Logami made B2 stress-free! As a Romanian nurse planning to work in Germany, I needed this. The vocabulary trainer is genius - I learned medical German easily. Passed with 87%!",
    verified: true,
    userInitials: "AP"
  },
  {
    id: 18,
    name: "Pavel Novak",
    location: "Prague, Czech Republic",
    exam: "telc C1",
    rating: 5,
    date: "2025-02-27",
    comment: "Best C1 preparation I've found! The materials are challenging but not overwhelming. I appreciated the detailed grammar sections. The writing lab is invaluable. Got 91%!",
    verified: true,
    userInitials: "PN"
  },
  {
    id: 19,
    name: "Katarzyna Kowalska",
    location: "Warsaw, Poland",
    exam: "Goethe B1",
    rating: 5,
    date: "2025-04-11",
    comment: "Perfect B1 course! Logami helped me understand German cases finally. The practice tests are realistic and the mobile app is great for studying anywhere. Passed on first try!",
    verified: true,
    userInitials: "KK"
  },
  {
    id: 20,
    name: "Viktor Ivanov",
    location: "Sofia, Bulgaria",
    exam: "Goethe",
    rating: 4,
    date: "2025-01-19",
    comment: "Very good Goethe The materials are comprehensive and mock exams are helpful. I needed this for university in Germany. Would love more listening exercises, but overall excellent.",
    verified: true,
    userInitials: "VI"
  },

  // ========== LATIN AMERICAN & SPANISH NAMES (15%) ==========
  {
    id: 21,
    name: "Carlos Mendoza",
    location: "Mexico City, Mexico",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-02-24",
    comment: "Logami is absolutely fantastic! German was intimidating at first. The B2 course is perfectly structured. I went from struggling to passing with 85%. The vocabulary system is amazing!",
    verified: true,
    userInitials: "CM"
  },
  {
    id: 22,
    name: "Maria Rodriguez",
    location: "Bogotá, Colombia",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-04-06",
    comment: "Best B2 preparation platform! I was nervous about German grammar. Logami made it clear and the interactive exercises kept me engaged. Passed with 85% on first attempt!",
    verified: true,
    userInitials: "MR"
  },
  {
    id: 23,
    name: "Isabella Costa",
    location: "São Paulo, Brazil",
    exam: "telc B1",
    rating: 4,
    date: "2025-01-29",
    comment: "Very good B1 course! The Portuguese-German similarities helped. Logami's explanations are clear and practice tests are realistic. Mobile app sometimes slow, but content is excellent.",
    verified: true,
    userInitials: "IC"
  },
  {
    id: 24,
    name: "Diego Fernandez",
    location: "Buenos Aires, Argentina",
    exam: "Goethe C1",
    rating: 5,
    date: "2025-03-04",
    comment: "Exceptional C1 preparation! As an engineer planning to work in Germany, I needed this. The writing section helped me improve my professional German tremendously. Got 93%!",
    verified: true,
    userInitials: "DF"
  },

  // ========== INDIAN NAMES (10%) ==========
  {
    id: 25,
    name: "Priya Sharma",
    location: "Mumbai, India",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-02-26",
    comment: "Logami is a game-changer! As an IT professional planning to move to Germany, I needed B2. The course is well-structured and the practice tests are excellent. Passed with 89%!",
    verified: true,
    userInitials: "PS"
  },
  {
    id: 26,
    name: "Raj Patel",
    location: "Bangalore, India",
    exam: "Goethe B2",
    rating: 5,
    date: "2025-04-01",
    comment: "Best B2 preparation! The mock exams are incredibly realistic. German pronunciation was hard, but the audio exercises helped immensely. Now ready for my Blue Card. Passed with 86%!",
    verified: true,
    userInitials: "RP"
  },
  {
    id: 27,
    name: "Ananya Kumar",
    location: "Delhi, India",
    exam: "Goethe C1",
    rating: 4,
    date: "2025-01-23",
    comment: "Very good C1 course! The reading materials are challenging and authentic. As a researcher planning my PhD in Germany, I needed this. Only wish there were more speaking practice options.",
    verified: true,
    userInitials: "AK"
  },

  // ========== ENGLISH/FRENCH NAMES (5%) ==========
  {
    id: 28,
    name: "James Wilson",
    location: "London, United Kingdom",
    exam: "telc B2",
    rating: 5,
    date: "2025-03-08",
    comment: "Excellent B2 preparation! I needed German for my job relocation to Germany. Logami's approach is systematic and effective. The vocabulary trainer with spaced repetition is brilliant. Passed with 87%!",
    verified: true,
    userInitials: "JW"
  },
  {
    id: 29,
    name: "Sophie Dubois",
    location: "Paris, France",
    exam: "Goethe C1",
    rating: 5,
    date: "2025-02-17",
    comment: "Outstanding C1 course! I appreciated the clear comparisons between French and German grammar. The writing lab helped me refine my essays to perfection. Passed with 92%. Merci Logami!",
    verified: true,
    userInitials: "SD"
  },

  // ========== ADDITIONAL DIVERSE REVIEW ==========
  {
    id: 30,
    name: "Lucia Gomez",
    location: "Santiago, Chile",
    exam: "telc B2",
    rating: 5,
    date: "2025-03-21",
    comment: "Logami made B2 achievable! I was worried about German complexity. The study plans are realistic and exercises are varied. The grammar section is particularly well-explained. Passed with 88%!",
    verified: true,
    userInitials: "LG"
  }
];

// Helper function to get reviews by exam type
export const getReviewsByExam = (examType) => {
  return reviews.filter(review => review.exam.includes(examType));
};

// Helper function to get top rated reviews
export const getTopRatedReviews = (count = 6) => {
  return reviews
    .filter(review => review.rating === 5)
    .slice(0, count);
};

// Helper function to calculate average rating
export const getAverageRating = () => {
  const total = reviews.reduce((sum, review) => sum + review.rating, 0);
  return (total / reviews.length).toFixed(1);
};

// Helper function to get review stats
export const getReviewStats = () => {
  const totalReviews = reviews.length;
  const averageRating = getAverageRating();
  const fiveStarCount = reviews.filter(r => r.rating === 5).length;
  const fourStarCount = reviews.filter(r => r.rating === 4).length;

  return {
    totalReviews: totalReviews,
    averageRating: parseFloat(averageRating),
    ratingDistribution: {
      5: fiveStarCount,
      4: fourStarCount,
      3: 0,
      2: 0,
      1: 0
    }
  };
};

export default reviews;